module.exports = __webpack_public_path__ + "img/zip_conveyancing.5d567b2f.png";